import React from 'react'
import { inject, observer } from 'mobx-react'
import { ComponentExt } from 'util/reactExt'
import { Tabs, Pagination, Modal } from 'antd'
// import Cate from 'components/layout/CateLayout'
import Preview from 'containers/shared/CoursePreview'
import Card from 'components/Card'
import styles from './index.scss'

const TabPane = Tabs.TabPane

@inject('globalStore')
@observer
class UHistory extends ComponentExt {
  state = {
    current: 1000101,
    tabList: [
      { name: '视频', type: 1000101 },
      { name: '文章', type: 1000102 },
      { name: '语音', type: 1000103 },
      { name: '专题', type: 1000104 },
      // { name: '外链', type: 1000105 },
      { name: '课件', type: 1100101 },
    ],
    historyData: { data: [], total: 0 },
    pageindex: 1,
    collectModal: false,
    isPreivew: false,
    previewData: {},
  }

  async componentDidMount() {
    if (this.state.tabList.length) {
      this.fetchUserStudyHistoryList(this.state.current, 1)
    }
  }

  async fetchUserStudyHistoryList(type, pageindex) {
    const res = await this.api.user.getUserStudyHistoryList({
      pageindex,
      pagesize: 9,
      type,
    })
    this.setState({
      historyData: res,
    })
  }

  async fetchDetail(id) {
    try {
      const { data } = await this.api.course.getArticleDetail(id)
      this.setState({
        previewData: data,
        isPreivew: true,
      })
    } catch (err) {
      console.error(err)
    }
  }

  handlePageChange = index => {
    this.fetchUserStudyHistoryList(this.state.current, index)
    this.setState({
      pageindex: index,
    })
  }

  handleTabClick(e) {
    this.fetchUserStudyHistoryList(e, 1)
    this.setState({
      current: e,
      pageindex: 1,
    })
  }

  cancelModal = () => this.setState({ isPreivew: false })

  toDetail = (id, type, content?) => {
    if (type === '1000104') {
      return window.open(`#/topicdetail/${id}`, '_blank')
    }
    if (type === '1000105') {
      return window.open(content, '_blank')
    }
    if (type.indexOf('1100') >= 0) {
      return this.fetchDetail(id)
    }
    window.open(`#/course/${id}?type=${type}`)
  }

  renderHandleBar = () => {
    const { tabList, current } = this.state

    return (
      <Tabs
        activeKey={current.toString()}
        onChange={e => this.handleTabClick(e)}
      >
        {tabList.map(tab => (
          <TabPane tab={`${tab.name}`} key={tab.name} />
        ))}
      </Tabs>
    )
  }
  render() {
    const { historyData, pageindex } = this.state

    const modalRender = info => (
      <Modal
        title={info.title || ''}
        visible={this.state.isPreivew}
        width={1000}
        style={{ top: '5%' }}
        onCancel={this.cancelModal}
        footer={null}
        bodyStyle={{ padding: 0 }}
      >
        <Preview info={info as any} />
      </Modal>
    )

    return (
      <div className={styles.userCollection}>
        <h3 className={styles.handleBar}>{this.renderHandleBar()}</h3>
        <section
          style={{
            backgroundColor: '#fff',
            padding: '32px 0',
          }}
        >
          <div
            style={{
              display: 'flex',
              padding: '0 16px',
              flexWrap: 'wrap',
              minHeight: '400',
            }}
          >
            {historyData.total > 0 ? (
              historyData.data.map(
                (
                  {
                    id,
                    img_url,
                    title,
                    view_count,
                    type,
                    course_time,
                    content,
                  },
                  idx,
                ) => (
                  <Card
                    key={`fccard-${idx}`}
                    cover={img_url}
                    title={title}
                    type="middle"
                    dataType={type}
                    watch={view_count}
                    time={course_time}
                    onClick={() => this.toDetail(id, type, content)}
                    style={{ marginBottom: 48, marginRight: 12 }}
                  />
                ),
              )
            ) : (
              <div
                style={{
                  margin: '0 auto',
                  lineHeight: '400px',
                  height: '400px',
                }}
              >
                暂无浏览记录
              </div>
            )}
          </div>
          <div style={{ textAlign: 'center' }}>
            <Pagination
              hideOnSinglePage={true}
              total={historyData.total}
              current={pageindex}
              onChange={this.handlePageChange}
            />
          </div>
        </section>
        {modalRender(this.state.previewData)}
      </div>
    )
  }
}

export default UHistory
